import version from "./version";

export const OUTPUT_CONSOLE_VERSION = `Supsis Ai v${version.versionStr}`;
